import { render, staticRenderFns } from "./XmlElement.vue?vue&type=template&id=27126924&scoped=true&"
import script from "./XmlElement.vue?vue&type=script&lang=js&"
export * from "./XmlElement.vue?vue&type=script&lang=js&"
import style0 from "./XmlElement.vue?vue&type=style&index=0&id=27126924&scoped=true&lang=scss&"
import style1 from "./XmlElement.vue?vue&type=style&index=1&id=27126924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27126924",
  null
  
)

export default component.exports